export type CartLine={productId:string;productTitle:string;variantId:string;variantName:string;unitPriceCents:number;currency:string;minorUnit?:number;quantity:number;imageUrl?:string};
const key='nanostylist:global:cart';
export const readCart=():CartLine[]=>{try{return JSON.parse(localStorage.getItem(key)??'[]') as CartLine[];}catch{return[];}};
export const writeCart=(lines:CartLine[])=>localStorage.setItem(key,JSON.stringify(lines));
